export enum DecoratorPermissionsType {
    ADD = "CrudDecorator.Add",
    UPDATE = "CrudDecorator.Update",
    SEARCH = "CrudDecorator.Search"
}
